import { Cpu, ListChecks, Bot, ScrollText, Sparkles, Package } from 'lucide-react';

// The workspace standards the MCP server serves. Their editors live under /docs
// now (moved off the Connect pillar, formerly /execute) — the Docs home surfaces
// them ("What your AI reads") and StandardsLayoutPage carries the tab strip. The
// `key`s are the stable identifiers the backend recommendation payloads, the MCP
// tool contract and the Learn page reference — don't fork them when the URL moves.
export const standardsSections = [
  {
    key: 'techStack' as const,
    to: '/docs/tech-stack',
    icon: Cpu,
    iconBg: 'bg-blue-100 dark:bg-blue-900/30',
    iconColor: 'text-blue-600 dark:text-blue-400',
    title: 'Tech Stack',
    description: 'Declare the frameworks, languages, and tools your team uses.',
  },
  {
    // key/route kept as 'guardrails' — backend recommendation payloads and the
    // MCP tool contract reference it
    key: 'guardrails' as const,
    to: '/docs/guardrails',
    icon: ListChecks,
    iconBg: 'bg-rose-100 dark:bg-rose-900/30',
    iconColor: 'text-rose-600 dark:text-rose-400',
    title: 'Checks',
    description: 'Capture AI mistakes and generate architecture fitness tests to prevent them.',
  },
  {
    key: 'aiConfig' as const,
    to: '/docs/model-settings',
    icon: Bot,
    iconBg: 'bg-purple-100 dark:bg-purple-900/30',
    iconColor: 'text-purple-600 dark:text-purple-400',
    title: 'Model Settings',
    description: 'Configure AI tool settings, project instructions, hooks, skills, and agents.',
  },
  {
    key: 'rules' as const,
    to: '/docs/rules',
    icon: ScrollText,
    iconBg: 'bg-teal-100 dark:bg-teal-900/30',
    iconColor: 'text-teal-600 dark:text-teal-400',
    title: 'Rules',
    description: 'Define project rules and principles that AI and your team must follow.',
  },
  {
    // key kept as 'rulesPrompts' — Learn-page recommendations reference it
    key: 'rulesPrompts' as const,
    to: '/docs/prompts',
    icon: Sparkles,
    iconBg: 'bg-amber-100 dark:bg-amber-900/30',
    iconColor: 'text-amber-600 dark:text-amber-400',
    title: 'Prompt Templates',
    description: 'Define reusable AI prompt templates for generating content.',
  },
  {
    // ADR-217: Docs › Skills became Docs › Team setup (skills, hooks and MCP,
    // instructions, memory). The key stays 'skills' for the stable contract.
    key: 'skills' as const,
    to: '/docs/team-setup',
    icon: Package,
    iconBg: 'bg-indigo-100 dark:bg-indigo-900/30',
    iconColor: 'text-indigo-600 dark:text-indigo-400',
    title: 'Team setup',
    description: "Your team's Claude Code setup: skills, hooks and MCP servers, instructions and memory, on any computer with one command.",
  },
];
